module.exports = __webpack_public_path__ + "img/caseImg3.7718e7cb.svg";